import { API_URLS } from "@/utils/constant/api.constant";
import { C_API } from "@/utils/helper/api";
import { useQuery } from "@tanstack/react-query";

const fetchDashboardInfo = async (params: { key?: string }): Promise<any> => {
  const response = await C_API.get(API_URLS.DASHBOARD.GET_INFO, { params: params });
  return response.data?.data;
};

export const useDashboardInfo = (params: { key?: string; page?: number; per_page?: number }) => {
  return useQuery<any, Error>({
    queryKey: ["dashboardInfo", params.key, params.page, params.per_page],
    queryFn: () => fetchDashboardInfo(params),
    refetchInterval: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
